module.exports = __webpack_public_path__ + "static/media/SPS_LOGO.45937a47.jpg";